import { useEffect } from "react";
import { enableForEnv, Stages } from "~/lib/utils";

declare global {
  interface Window {
    Calendly?: {
      initPopupWidget?: (options: { url: string }) => void;
      initBadgeWidget?: (options: {
        url: string;
        text?: string;
        color?: string;
        textColor?: string;
      }) => void;
      initInlineWidget?: (options: {
        url: string;
        parentElement: HTMLElement;
        prefill?: {
          name?: string;
          email?: string;
          customAnswers?: Record<string, string>;
        };
      }) => void;
    };
  }
}

export const CalendlyWidget = () => {
  const isEnabled = enableForEnv([
    Stages.PRODUCTION,
    Stages.STAGING,
    Stages.DEV,
    Stages.LOCAL,
  ]);

  useEffect(() => {
    if (!isEnabled) return;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      link.remove();
      script.remove();
    };
  }, [isEnabled]);

  return null;
};
